__turbopack_context__.v({
  "body": "code-block-module__pEb5LG__body",
  "codePane": "code-block-module__pEb5LG__codePane",
  "collapseToggle": "code-block-module__pEb5LG__collapseToggle",
  "collapsed": "code-block-module__pEb5LG__collapsed",
  "copy": "code-block-module__pEb5LG__copy",
  "copyFloating": "code-block-module__pEb5LG__copyFloating",
  "copyHoverReveal": "code-block-module__pEb5LG__copyHoverReveal",
  "fileTitle": "code-block-module__pEb5LG__fileTitle",
  "header": "code-block-module__pEb5LG__header",
  "minimap": "code-block-module__pEb5LG__minimap",
  "minimapAmber": "code-block-module__pEb5LG__minimapAmber",
  "minimapCherry": "code-block-module__pEb5LG__minimapCherry",
  "minimapContent": "code-block-module__pEb5LG__minimapContent",
  "minimapForest": "code-block-module__pEb5LG__minimapForest",
  "minimapLine": "code-block-module__pEb5LG__minimapLine",
  "minimapRobin": "code-block-module__pEb5LG__minimapRobin",
  "minimapTrack": "code-block-module__pEb5LG__minimapTrack",
  "minimapViewport": "code-block-module__pEb5LG__minimapViewport",
  "nested": "code-block-module__pEb5LG__nested",
  "pre": "code-block-module__pEb5LG__pre",
  "root": "code-block-module__pEb5LG__root",
  "tab": "code-block-module__pEb5LG__tab",
  "tabActive": "code-block-module__pEb5LG__tabActive",
  "tabButton": "code-block-module__pEb5LG__tabButton",
  "tabIcon": "code-block-module__pEb5LG__tabIcon",
  "tabInner": "code-block-module__pEb5LG__tabInner",
  "tabList": "code-block-module__pEb5LG__tabList",
  "tabPanel": "code-block-module__pEb5LG__tabPanel",
  "tabUnderline": "code-block-module__pEb5LG__tabUnderline",
  "title": "code-block-module__pEb5LG__title",
  "titleIcon": "code-block-module__pEb5LG__titleIcon",
});
